<template>
  <div class="space-y-8">
    <div v-for="(variant, index) in variants" :key="index" class="space-y-4">

      <h2 class="text-xl font-semibold">
        Variant: {{ variant }}
      </h2>

      <div v-for="(size, sizeIndex) in sizes" :key="sizeIndex" class="ml-4 space-y-2">

        <h3 class="text-lg font-medium">
          Size: {{ size }}
        </h3>

        <div class="flex gap-6 flex-wrap ml-4">
          <div v-for="state in states" :key="state.label" class="space-y-1">
            <Button
                v-if="!(state.label === 'Loading' && size === 'icon') && !(state.extra.icon && size === 'icon')"
                :variant="variant"
                :size="size"
                v-bind="state.extra"
                @mousedown="focus"
            >

            <HeartIcon v-if="state.extra.icon && size !== 'icon'" class="size-4" />

              {{ size === "icon" ? "o" : "Button" }}
            </Button>

          </div>
        </div>

      </div>
    </div>


  </div>
</template>

<script lang="ts" setup>
import { ButtonVariants } from '@/components/ui/button';
import { HeartIcon } from 'lucide-vue-next';

const variants = ["default", "secondary", "destructive", "outline", "ghost", "link", "plain"] as ButtonVariants['variant'][];
const states = [
  { label: "Default", extra: {} },
  { label: "Default with icon", extra: { icon: true } },
  { label: "Loading", extra: { disabled: true, loading: true } },
  { label: "Disabled", extra: { disabled: true } },
]

const sizes = ["default", "sm", "lg", "icon"] as ButtonVariants['size'][];

const focus = (event: Event) => {
  event.currentTarget?.focus()
}

</script>